import React from 'react';

const FarmWeather = ({ menuOpen, weather }) => {
  return (
    <div
      className={`flex flex-wrap justify-center mt-10 px-5 md:px-0 ${
        menuOpen ? 'pl-8 md:pl-24' : ''
      }`}
    >
      <div className="w-full md:w-4/5 lg:w-133 bg-white rounded px-3 md:px-6 py-4">
        <div className="flex flex-wrap">
          <div className="flex items-center">
            <h6>Weather</h6>
            <div className="md:hidden ml-16">
              <img
                className="w-16 block h-10"
                src={`https://openweathermap.org/img/w/${weather.icon}.png`}
                alt={weather.description}
              />
              <span className="-mt-4 block text-center text-tiny capitalize">
                {weather.description}
              </span>
            </div>
          </div>
          <div className="mt-8 bg-cf-100 rounded p-4 text-cf-300 w-full md:ml-24">
            <div className="flex flex-wrap text-center md:text-left justify-between items-center">
              <div className="hidden md:block">
                <img
                  className="w-16 block h-10"
                  src={`https://openweathermap.org/img/w/${weather.icon}.png`}
                  alt={weather.description}
                />
                <span className="-mt-4 block text-center text-tiny capitalize">
                  {weather.description}
                </span>
              </div>

              <div>
                <p className="font-header">{weather.tair} ºC</p>
                <span className="block text-tiny">Temp</span>
              </div>

              <div>
                <p className="font-header">{weather.rh}%</p>
                <span className="block text-tiny">Rel Humidity</span>
              </div>

              <div>
                <p className="font-header">{weather.p} kPa</p>
                <span className="block text-tiny">Pressure</span>
              </div>

              <div>
                <p className="font-header">{Math.round(weather.wind_speed * 3.6)} km/hr</p>
                <span className="block text-tiny">wind Speed</span>
              </div>

              <div>
                <p className="font-header">{weather.precip || 0} mm</p>
                <span className="block text-tiny">Precipitation</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmWeather;
